<script setup lang="ts">
import type { FlightProductCardData } from '../../../models';

import FlightProductCardContent from './FlightProductCardContent.vue';

interface FlightProductCardProps {
  productCardData: FlightProductCardData;
  printMode: boolean;
}

const props = defineProps<FlightProductCardProps>();

interface FlightProductCardEmits {
  (event: 'show-details'): void;
}

const emit = defineEmits<FlightProductCardEmits>();

function showDetails(): void {
  if (!props.printMode) {
    emit('show-details');
  }
}
</script>

<template>
  <div
    class="flight-product-card"
    :class="{ 'print-mode': props.printMode }"
    @click="emit('show-details')"
  >
    <FlightProductCardContent
      :product-card-content="props.productCardData"
      @show-details="showDetails"
    />
  </div>
</template>

<style scoped lang="scss">
.flight-product-card {
  background: var(--color-white);
  border: 1px solid var(--color-secondary-93);
  border-radius: var(--border-radius-12);
  overflow: hidden;

  &:not(.print-mode) {
    @include on-hover {
      background: var(--color-secondary-95);
      transition: background var(--transition-short);
      cursor: pointer;
    }
  }
}
</style>
